"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Plural = ({ value, one, other }) => {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: value === 1 ? one.replace('#', value.toString()) : other.replace('#', value.toString()) });
};
exports.default = Plural;
